import { createConsola } from "consola";

// Consola log levels: 0=Fatal/Error, 1=Warn, 2=Log, 3=Info, 4=Debug, 5=Trace
const LOG_LEVELS: Record<string, number> = {
  silent: -1,
  error: 0,
  warn: 1,
  info: 3,
  debug: 4,
  trace: 5,
};

/**
 * Resolves the log level based on environment:
 * - Local / Dev (NODE_ENV=development): debug — full visibility for developers
 * - QA / Staging / UAT / Production (NODE_ENV=production): warn — minimal noise, no sensitive data
 */
function resolveLevel(): number {
  return process.env.NODE_ENV === "development" ? LOG_LEVELS.debug : LOG_LEVELS.warn;
}

export const logger = createConsola({
  level: resolveLevel(),
  defaults: {
    tag: "AIDA",
  },
});
